import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/dashboard")({
  head: () =>
    pageHead(
      "Partner Dashboard",
      "Your authorized Partner company workspace.",
      "/partner/dashboard",
      true,
    ),
  component: () => <PartnerWorkspacePage section="dashboard" />,
});
